export default __webpack_public_path__ + "locales/ru/EmptyTrashDialog.json?hash=4b77db81d05fc45ad4c65b934e909f0f";